import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import Footer from '../../components/Footer';
import { Header } from '../../components/Header';
import { Card } from './components/Card';
import { CommentsModal } from './components/CommentsModal';

import { apiNode, apiPHP } from '../../services/api';
import { swiperBreakpointsOptions } from '../../utils/swiperBreakpointsOptions';
import { NavigateToTournamentsPage } from '../../utils/NavigateToTournamentsPage';

import background1 from '../../assets/img/banner1.jpg';
import background2 from '../../assets/img/banner2.jpg';
// import background3 from '../../assets/img/banner3.jpg';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Banner, Container, GameList, GamesContainer, Row } from './styles';

interface PassatempoProps {
  id_jogo: number;
  edicoes_id: number;
  id_dificuldade: number;
  id_tipo: number;
  titulo: string;
  subtitulo: string;
  created_at: string;
  curtidas_count?: number;
  comentarios_count?: number;
}

interface TournamentProps {
  id: number;
  foto: string;
  nome: string;
  subtitulo: string;
  edition: string;
  created_at: string;
  dificuldades: {
    nome: string;
    id: number;
  };
}

interface SectionProps {
  id: number;
  name: string;
  createdAt: string;
  jogos: PassatempoProps[];
}

export const Home: React.FC = () => {
  const navigate = useNavigate();
  SwiperCore.use([Autoplay]);

  const [isLoading, setIsLoading] = useState(false);
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  const [gameId, setGameId] = useState(0);
  const [tournaments, setTournaments] = useState<TournamentProps[]>([]);

  const [sections, setSections] = useState<SectionProps[]>([]);

  useEffect(() => {
    try {
      const getSections = async () => {
        setIsLoading(true);
        const response = await apiNode.get('/home');

        const formattedSections = response.data.map((section: any) => {
          let games = section.jogos;

          section.palavras.forEach((palavra: any) => {
            const formattedPalavra = {
              ...palavra,
              id_jogo: palavra.passatempos_id,
              titulo: `Palavras Cruzadas #${palavra.passatempos_id}`,
              id_tipo: 3,
            };
            games.push(formattedPalavra);
          });

          if (section.caca_palavras.length > 0) {
            section.caca_palavras.forEach((cacaPalavra: any) => {
              const formattedCacaPalavra = {
                ...cacaPalavra,
                titulo: `Caça Palavras ${cacaPalavra.id_jogo}`,
                id_tipo: 7,
              };
              games.push(formattedCacaPalavra);
            });
          }

          return {
            ...section,
            jogos: games,
          };
        });

        setSections(formattedSections);
        setIsLoading(false);
      };

      getSections();
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    try {
      const getTournaments = async () => {
        setIsLoading(true);
        const response = await apiPHP.get('/jogo/torneios');

        setTournaments(response.data);
        setIsLoading(false);
      };

      getTournaments();
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, []);

  const handleOpenCommentsModal = (id: number) => {
    setGameId(id);
    setIsCommentsModalOpen(true);
  };

  const handleUpdatePassatemposCommentsCount = () => {
    const updatedSectionsList = sections.map((section) => {
      const updatedGamesSection = section.jogos.map((game) => {
        if (game.id_jogo === gameId) {
          if (game.comentarios_count) {
            return {
              ...game,
              comentarios_count: game.comentarios_count + 1,
            };
          } else {
            return {
              ...game,
            };
          }
        }
        return game;
      });

      return {
        ...section,
        jogos: updatedGamesSection,
      };
    });

    setSections(updatedSectionsList);
    setGameId(0);
    setIsCommentsModalOpen(false);
  };

  const handleUpdateGameSectionLikeCount = (
    operation: string,
    sectionId: number,
    gameId: number
  ) => {
    const section = sections.filter((section) => section.id === sectionId);
    const updatedGamesSection = section[0].jogos.map((game) => {
      if (game.id_jogo === gameId) {
        if (game.curtidas_count) {
          return {
            ...game,
            curtidas_count:
              operation === 'like'
                ? game.curtidas_count + 1
                : game.curtidas_count - 1,
          };
        } else {
          return {
            ...game,
          };
        }
      }
      return game;
    });

    const updatedSectionsList = sections.map((section) => {
      if (section.id === sectionId) {
        return {
          ...section,
          jogos: updatedGamesSection,
        };
      } else {
        return section;
      }
    });
    setSections(updatedSectionsList);
  };

  return (
    <Container>
      <Header />
      <Banner>
        <Swiper
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          loop={true}
          navigation={true}
          modules={[Pagination, Navigation]}
          className="mySwiper"
        >
          <SwiperSlide>
            <img src={background1} alt="Logo 1" />
            <span className="shadow" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={background2} alt="Logo 2" />
            <span className="shadow" />
          </SwiperSlide>
          {/* <SwiperSlide
            onClick={() => navigate('/tournaments')}
            style={{ cursor: 'pointer' }}
          >
            <img src={background3} alt="Logo 3" />
            <span className="shadow" />
          </SwiperSlide> */}
        </Swiper>
      </Banner>
      <GamesContainer>
        <h1>Jogue Agora!</h1>
        <GameList>
          <a href="#Cruzadas Tradicionais">
            <span>caça-palavras</span>
          </a>
          <a href="#Cruzadas Tradicionais">
            <span>palavras cruzadas</span>
          </a>
          <a href="#Sudokus">
            <span>sudoku</span>
          </a>
          <a href="#Rébus">
            <span>rébus</span>
          </a>
        </GameList>

        {sections.map(
          (section) =>
            section.jogos.length > 0 && (
              <Row id={section.name} key={section.id}>
                <h2>{section.name}</h2>
                <Swiper
                  loop={true}
                  loopFillGroupWithBlank={true}
                  navigation={true}
                  modules={[Pagination, Navigation]}
                  breakpoints={swiperBreakpointsOptions}
                  className="mySwiper"
                >
                  {!isLoading &&
                    section.jogos.map((game) => (
                      <SwiperSlide
                        key={`${game.titulo} ${game.id_jogo} ${Math.floor(
                          Math.random() * 100
                        )}`}
                      >
                        <Card
                          sectionId={section.id}
                          game={game}
                          openCommentsModal={handleOpenCommentsModal}
                          updateGameSectionLikeCount={
                            handleUpdateGameSectionLikeCount
                          }
                        />
                      </SwiperSlide>
                    ))}
                </Swiper>
              </Row>
            )
        )}
        <Row>
          {tournaments.length > 0 && (
            <>
              <h2>Torneios</h2>
              <Swiper
                // slidesPerView={4}
                // spaceBetween={370}
                // slidesPerGroup={4}
                loop={true}
                navigation={true}
                modules={[Pagination, Navigation]}
                className="mySwiper"
                breakpoints={swiperBreakpointsOptions}
              >
                {tournaments &&
                  !isLoading &&
                  tournaments.map((tournament) => (
                    <SwiperSlide key={`Torneios ${tournament.id}`}>
                      <Card
                        game={{
                          id_jogo: tournament.id,
                          id_dificuldade: tournament.dificuldades.id,
                          titulo: tournament.nome,
                          subtitulo: tournament.subtitulo,
                          created_at: tournament.created_at,
                        }}
                        openCommentsModal={handleOpenCommentsModal}
                        updateGameSectionLikeCount={
                          handleUpdateGameSectionLikeCount
                        }
                        navigateToTournaments={() =>
                          NavigateToTournamentsPage(navigate, tournament.id)
                        }
                      />
                    </SwiperSlide>
                  ))}
              </Swiper>
            </>
          )}
        </Row>
      </GamesContainer>
      <Footer />

      <CommentsModal
        isOpen={isCommentsModalOpen}
        closeModal={() => setIsCommentsModalOpen(false)}
        gameId={gameId}
        updatePassatemposCommentsCount={handleUpdatePassatemposCommentsCount}
      />
    </Container>
  );
};
